module.exports = __webpack_public_path__ + "static/media/favicon.e7f6a66a.ico";